import {
  Component,
  OnInit,
  Inject,
} from '@angular/core';
import { CMS } from '../cms/cms.component';
import {
  fontAwesomeicons,
  simpleLineIcons,
} from '../../constants/icon.constants';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-cms-edit-form',
  templateUrl: './cms-edit-form.component.html',
  styleUrls: ['./cms-edit-form.component.scss'],
})
export class CmsEditFormComponent implements OnInit {
  public cms: CMS = {  
    id: 0,
    panelKey: '',
    panelTitle: '',
    panelTitleClass: null,
    panelTitleIcon: null,
    panelClass: null,
    hasHeader: false,
    panelValue: '',
    panelEditors: '',
    version: 0,
    isVisible: 0,
    comments: '',
    createdDate: '',
    updatedDate: '',
    creatorUid: '',
    updatedUid: '',
    updatedDateFmt: '',
    updatedName: ''
  };
  allIcons: any = [fontAwesomeicons];
  icons = this.allIcons;
  selectionClasses: string[] = [
    'bg-primary',
    'bg-secondary',
    'bg-success',
    'bg-danger',
    'bg-warning',
    'bg-info',
    'bg-light',
    'bg-dark',
    'bg-white',
    'text-primary',
    'text-secondary',
    'text-success',
    'text-danger',
    'text-warning',
    'text-info',
    'text-light',
    'text-dark',
    'text-muted',
    'text-white',
  ];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.cms) {
      this.cms = data.cms;
      this.cms.panelTitleClass
        ? (this.cms.panelTitleClass = this.cms.panelTitleClass)
        : (this.cms.panelTitleClass = null);
      this.cms.panelClass
        ? (this.cms.panelClass = this.cms.panelClass)
        : (this.cms.panelClass = null);
      this.cms.hasHeader = (this.cms.hasHeader === "true" || this.cms.hasHeader == true) ? true : false;
    }
    if (data.classes && data.classes.length) {
      this.selectionClasses = data.classes;
    }
  }

  ngOnInit() {
    this.icons = [...fontAwesomeicons, ...simpleLineIcons];
  }
}
